import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-replace-existing-document',
  templateUrl: './confirm-replace-existing-document.component.html',
  styleUrls: ['./confirm-replace-existing-document.component.scss']
})
export class ConfirmReplaceExistingDocumentComponent  {
  
  constructor(private dialogRef: MatDialogRef<ConfirmReplaceExistingDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {name: string}) { }

    replaceHandler(){
      
      this.dialogRef.close(true);
    }
    cancelHandler(){
      this.dialogRef.close(false);
    }
}
